import { AttendanceHistoryItems, AttendanceHistoryTable } from './model';
import { moment } from 'omni-common-ui';
import { Interval } from 'domain/Interval';

const getStatusDisplayName = (statusName) => {
  if (! statusName) return '-';
  switch (statusName) {
    case 'UnMarked':
      return 'Not Marked';
    case 'NotApplicable':
      return 'Not Applicable';
    default:
      return statusName;
  }
};

const getActionDisplayName = (actionName) => {
  if (! actionName) return '-';
  switch (actionName) {
    case 'U':
    case 'D':
      return 'Edit';
    case 'I':
      return 'New';
    default:
      return actionName;
  }
};

const reviverHistoryItems = ([key, item]) => {
  if (! item) return [key, item];
  switch (key) {
    case 'action':
      return [key, getActionDisplayName(item)];
    case 'previousStatus':
    case 'currentStatus':
      return [key, getStatusDisplayName(item)];
    case 'actionTime':
      return [key, moment.utc(item)];
    case 'sessionDuration':
      return [key, Interval.create({
        start: item.startDate,
        end: item.endDate,
      })];
    default:
      return [key, item];
  }
};

const createHistoryItems = (data) => {
  const attendanceHistoryItems = [];
  if (data) {
    data.forEach((historyObject) => {
      const newHistoryObject = JSON.parse(JSON.stringify(historyObject));
      newHistoryObject.studentName = `${newHistoryObject.studentFirstName} ${newHistoryObject.studentLastName}`;
      newHistoryObject.editedByName = `${newHistoryObject.editedByFirstName} ${newHistoryObject.editedByLastName}`;
      attendanceHistoryItems.push(new AttendanceHistoryItems(newHistoryObject)
        .mapEntries(reviverHistoryItems));
    });
  }

  return attendanceHistoryItems;
};

const reviver = ([key, item]) => {
  if (! item) return [key, item];
  switch (key) {
    case 'studentAttendanceHistories':
      return [key, createHistoryItems(item)];
    default:
      return [key, item];
  }
};

const create = (data) => new AttendanceHistoryTable(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/AttendanceHistory/model/create.js